import {
  FilteredProduct,
  Product,
  AttributeOptionSet,
  GroupParentAttributeOptionSet,
  Option,
  ParentAttributeOptionSet,
  GroupParentAttributeOptionSetValue,
} from "@/components/configurator/global-option/types";
import { ProductAttributesViaGroup } from "@/components/configurator/body-option/body-options-actions/types";
import {
  Attribute,
  AttributeSet,
  FinalData,
  SelectedOptions,
  SelectedParent,
} from "@/components/configurator/body-option/selector/type";
import getCpqQuotes from "@/utils/magento/quotes/get-cpq-quotes";
import getCpqQuoteProducts from "@/utils/magento/quotes/get-cpq-quote-products";
import {
  BodyUnitBody,
  DukeActiveQuote,
  CUSTOMER_DETAILS_KEY,
  customerOperations,
  priceOperations,
  quoteOperations,
  sessionStorageOperations,
  updatePriceInGlobalPick,
  removeFormData
} from "@/utils/form-data-manager";
import { globalOptionResources } from "@/utils/storage-manager/global-options";
import { SingleValue } from "react-select";
import Serialize from "@/utils/serialize";
import Deserialize from "@/utils/deserialize";
import getQuotePricesByQuoteId from "@/utils/configurator-actions/get-prices";
import getFormFields from "@/utils/magento/quotes/get-form-fields";
import {
  createGroupByAll,
  getGroupAttributeCodeSetSource,
} from "@/components/configurator/global-option/helper";
import { GroupAttributeCodeSetSource } from "@/components/configurator/global-option/types";
import { GlobalOptions } from "@/utils/form-data-manager";

const nullAttributeOptionSet: AttributeOptionSet = {
  attributeCode: "",
  defaultOption: {
    label: "",
    value: "",
    isDisabled: false,
  },
  selectedOption: {
    label: "",
    value: "",
    isDisabled: false,
  },
  labelOptions: {
    label: "",
    options: [
      {
        label: "",
        value: "",
        isDisabled: false,
      },
    ],
  },
  isDisabled: false,
  isGrayOut: false,
  dukeGeneralRowsContainer: {},
};

export function refractorDataBasedOnParents(data: AttributeSet) {
  const newData: { [key: string]: Attribute[] } = {};

  data.forEach((key: Attribute) => {
    newData[key.group] = [];
  });

  data.forEach((key: Attribute) => {
    key.field_options = key.field_options.map((option) => ({
      ...option,
      isDisabled: false,
    }));

    newData[key.group].push(key);
  });

  return newData;
}

export function refractorDataBasedOnGroups(data: {
  [key: string]: AttributeSet;
}) {
  const newData: { [key: string]: { [key: string]: Attribute[] } | {} } = {};

  Object.keys(data).forEach((groupKey) => {
    newData[groupKey] = [];
  });

  Object.keys(data).forEach((groupKey) => {
    const parentMap: any = {};

    data[groupKey].forEach((attribute: Attribute) => {
      const parentKey = attribute.parent === "" ? "null" : attribute.parent;
      parentMap[parentKey] = [];
    });

    data[groupKey].forEach((attribute: Attribute) => {
      const parentKey = attribute.parent === "" ? "null" : attribute.parent;

      attribute.field_options = attribute.field_options.map((option) => ({
        ...option,
        isDisabled: false,
      }));

      parentMap[parentKey].push(attribute);
    });

    newData[groupKey] = parentMap;
  });

  return newData;
}

export function buildInitialState(data: FinalData) {
  const initialSelectedOptions: SelectedOptions = {};

  // Building Group
  Object.keys(data).forEach((group: string) => {
    initialSelectedOptions[group] = {};
  });

  Object.keys(data).forEach((group: string) => {
    Object.keys(data[group]).forEach((parent: string) => {
      initialSelectedOptions[group][parent] = {};
    });
    Object.keys(data[group]).forEach((parent: string) => {
      data[group][parent].forEach((attribute: Attribute) => {
        initialSelectedOptions[group][parent][attribute.attribute_code] = "";
      });
    });
  });
  return initialSelectedOptions;
}

export function buildInitialPar(data: FinalData) {
  const initialSelectedOptions: SelectedParent = {};

  // Building Group
  Object.keys(data).forEach((group: string) => {
    initialSelectedOptions[group] = {};
  });

  Object.keys(data).forEach((group: string) => {
    Object.keys(data[group]).forEach((parent: string) => {
      initialSelectedOptions[group][parent] = false;
    });
  });
  return initialSelectedOptions;
}

export const checkSelected: (
  data: SelectedOptions,
  parent: string,
  group: string
) => boolean = (data: SelectedOptions, parent: string, group: string) => {
  let cnt: number = 0;
  if (parent === "" || group === "") return true;
  Object.keys(data[group][parent]).forEach((a_code) => {
    if (data[group][parent][a_code] !== "") {
      cnt++;
    }
  });
  if (cnt === Object.keys(data[group][parent]).length) return false;
  return true;
};

export function BodyPartsInitialState(data: any) {
  const isOpened: { [val: number]: boolean } = {};
  Object.keys(data).forEach((keys, index) => {
    isOpened[index] = false;
  });
  return isOpened;
}

export function dbg(...val: any) {
  let currentDate = new Date();

  // Get the current hours, minutes, and seconds
  let hours = currentDate.getHours();
  let minutes = currentDate.getMinutes();
  let seconds = currentDate.getSeconds();

  // Format the time as HH:MM:SS
  let currentTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

export function extractGroupGroupId(data: FinalData) {
  const groupGroupId: { group: string; group_id: string }[] = [];
  Object.keys(data).forEach((group: any) => {
    Object.keys(data[group]).forEach((parent: string) => {
      groupGroupId.push({
        group: group,
        group_id: data[group][parent][0].group_id,
      });
    });
  });
  return groupGroupId;
}

export function getGroupId(
  groupName: string,
  extractFrom: { group: string; group_id: string }[]
) {
  let groupId = "";
  extractFrom.forEach((group) => {
    if (group.group === groupName) groupId = group.group_id;
  });
  return groupId;
}

export function snakeCaseBuilder(val: string) {
  return val.toLowerCase().replace(/ /g, "_");
}

export function deepClone(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

export function formatPrice(price: any) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    currencyDisplay: "narrowSymbol",
  });

  return formatter.format(price);
}

export const addGlobalApplianceWithCounterBody = (
  fetchedProduct: Product,
  globalAppliance: FilteredProduct[]
): ProductAttributesViaGroup[] => {
  const neglectKeys = ["image", "name", "price", "sku"];
  const applianceData: ProductAttributesViaGroup[] = [];
  Object.keys(fetchedProduct).forEach((key: string) => {
    if (!neglectKeys.includes(key) && fetchedProduct[key]) {
      applianceData.push({
        attribute_code: key,
        attribute_value: fetchedProduct[key],
      });
    }
  });
  if (globalAppliance) {
    globalAppliance.forEach((appliances: FilteredProduct) => {
      appliances.products.forEach((product) => {
        Object.keys(product).forEach((key: string) => {
          if (!neglectKeys.includes(key)) {
            applianceData.push({
              attribute_code: key.replace(/_Voltage$/, "-Voltage"),
              attribute_value: product[key],
            });
          }
        });
      })
      
    });
  }
  return applianceData;
};

export const getDukeActiveQuote = async (
  cpqQuoteId?: number | undefined,
  salesforceQuoteId?: string,
  groupParentAttributeOptionSet?: GroupParentAttributeOptionSet,
  fetchedSalesforceQuoteName?:string | undefined
): Promise<DukeActiveQuote> => {
  if (!salesforceQuoteId && !cpqQuoteId) {
    throw new Error("salesforceQuoteId or cpqQuoteId is required");
  }

  try {
    const quoteParams: { salesforce_quote_id?: string; cpq_quote_id?: number } =
      {};

    //Identify if the locally stored quote is the same as requested
    const quoteIdMatch = salesforceQuoteId
      ? quoteOperations.getSalesforceQuoteId() == salesforceQuoteId
      : quoteOperations.getQuoteId() == cpqQuoteId;

    if (quoteIdMatch) {
      return quoteOperations.getQuote();
    }

    salesforceQuoteId
      ? (quoteParams.salesforce_quote_id = salesforceQuoteId)
      : (quoteParams.cpq_quote_id = cpqQuoteId);
    const quoteData = await getCpqQuotes(quoteParams);


    if (quoteData.data.getCpqQuotes.length === 0 && salesforceQuoteId && groupParentAttributeOptionSet) {

      const EmptyDukeActiveQuote = {
        id_quote: 0,
        quote_name: fetchedSalesforceQuoteName ?? 'New Quote',
        global_picks_data: {
          global_picks: mapDukeActiveStructure(groupParentAttributeOptionSet),
          additionalData: [],
        },
        bodies: [],
        salesforce_quote_id_with_suffix: salesforceQuoteId,
        subTotal: 0,
        totalCost: 0,
        totalPrice: 0,
      };

      quoteOperations.setQuote(EmptyDukeActiveQuote);

      return EmptyDukeActiveQuote;
    }

    const cpqQuoteIdFinal = Number(quoteData.data.getCpqQuotes[0].cpq_quote_id);
    const quoteTitle = quoteData.data.getCpqQuotes[0].quote_title;

    const globalPicksData = JSON.parse(
      quoteData.data.getCpqQuotes[0]?.duke_active_quote
    );

    const quoteProductData = await getCpqQuoteProducts(cpqQuoteIdFinal);

    const cpqQuotePrices = await getQuotePricesByQuoteId(cpqQuoteIdFinal);

    const productFormPicks: BodyUnitBody[] = [];

    const productPricingMap = new Map(
      cpqQuotePrices.products.map((el) => [el.id, el])
    );

    let productFormPicksMapPairs: [string, BodyUnitBody][] = [];
    quoteProductData.data.getCpqQuoteProducts.forEach(
      (product: { product_form_picks: string }) => {
        try {
          if (!product.product_form_picks) return;

          let productData = JSON.parse(product.product_form_picks);

          if (productData?.epicor_product_id) {
            productData.pricingDetails =
              productPricingMap.get(productData.epicor_product_id) || null;
            productData.global_picks_data.additionalData =
              updatePriceInGlobalPick(
                productData.global_picks_data.additionalData,
                productData.pricingDetails
              );
          }

          productFormPicks.push(productData);
          productFormPicksMapPairs.push([
            String(productData?.epicor_product_id),
            productData,
          ]);
        } catch (error) {
          console.error("Error parsing product_form_picks:", error);
        }
      }
    );

    let productFormPicksMap = new Map(productFormPicksMapPairs);

    let sortedProductFormPicks: BodyUnitBody[] = cpqQuotePrices.products
      .map((product) => productFormPicksMap.get(String(product.id)))
      .filter((value): value is BodyUnitBody => value !== undefined);

    const dukeActiveQuoteCurrent = {
      id_quote: cpqQuoteIdFinal,
      quote_name: quoteTitle,
      global_picks_data: globalPicksData.global_picks_data,
      bodies: sortedProductFormPicks,
      salesforce_quote_id_with_suffix: salesforceQuoteId ?? null,
      subTotal: cpqQuotePrices.subtotal,
      totalCost: cpqQuotePrices.totalCost,
      totalPrice: cpqQuotePrices.totalPrice,
    };

    quoteOperations.setQuote(dukeActiveQuoteCurrent);

    return dukeActiveQuoteCurrent;
  } catch (error) {
    console.error("Error fetching quote data:", error);
    throw new Error("Failed to retrieve DukeActiveQuote");
  }
};

//* Salesforce
export const findQuoteItemInSalesforceData = (
  idProduct: number,
  salesforceData: any
) => {
  const foundProduct = salesforceData.lineItems.find((item: any) => {
    return Number(item.record.ECPQConfiguredProductId__c) === idProduct;
  });

  return foundProduct ? foundProduct.record.Id : "";
};

/**
 * Deletes data from session storage and other areas of the application.
 * If logoutCleanups is "logoutCleanup", then the customer details are also removed.
 * Otherwise, the global options data is removed.
 */
export const sessionStorageCleanup = (logoutCleanup?: string) => {
  if (logoutCleanup == "logoutCleanup") {
    sessionStorage.removeItem(CUSTOMER_DETAILS_KEY);
    customerOperations.deleteLoggedInCustomerDetails();
  } else {
    sessionStorageOperations.deleteDataByKey("SELECTED_GLOBAL_OPTIONS");
  }
  quoteOperations.deleteQuote();
  globalOptionResources.remove();
  priceOperations.deleteQuotePrices();
  removeFormData();
};

//new Implementaion
export function transformToFinalData(
  data: GroupParentAttributeOptionSet
): SelectedOptions {
  let finalData: SelectedOptions = {};

  data.forEach((group, groupId) => {
    if (!finalData[group.groupName]) {
      finalData[group.groupName] = {};
    }

    group.parents.forEach((parent, parentLabel) => {
      if (!finalData[group.groupName][parentLabel]) {
        finalData[group.groupName][parentLabel] = {};
      }

      parent.child.forEach((attribute) => {
        if (attribute.selectedOption?.value) {
          finalData[group.groupName][parentLabel][attribute.attributeCode] =
            attribute.selectedOption.value;
        } else {
          finalData[group.groupName][parentLabel][attribute.attributeCode] = "";
        }
      });
    });
  });

  return finalData;
}

export function updateBodyOptionSelections(
  groupParentAttributeOptionSet: GroupParentAttributeOptionSet,
  selectedOption: SingleValue<Option>,
  value: AttributeOptionSet,
  parent: string,
  groupKey: string
): GroupParentAttributeOptionSet {
  const parents: Map<string, ParentAttributeOptionSet> | null =
    groupParentAttributeOptionSet.get(groupKey)?.parents ?? null;

  if (!parents) return groupParentAttributeOptionSet;

  const parentMap = new Map(parents);

  let parentSelectedOptions =
    parentMap.get(parent)?.parentSelectedOptions ?? [];

  const attributeOptionToUpdate: AttributeOptionSet =
    groupParentAttributeOptionSet
      .get(groupKey)
      ?.parents.get(parent)
      ?.child?.filter(
        (labelOptions) => labelOptions.attributeCode === value.attributeCode
      )
      .at(0) ?? nullAttributeOptionSet;

  if (selectedOption?.value === value.selectedOption?.value) {
    attributeOptionToUpdate.selectedOption = {
      label: "",
      value: "",
      isDisabled: false,
    };
    parentSelectedOptions = parentSelectedOptions.filter(
      (item) => item !== selectedOption!.value
    ); // field dependency logic
  } else if (
    selectedOption &&
    selectedOption?.value !== value.selectedOption?.value
  ) {
    attributeOptionToUpdate.selectedOption = selectedOption;
    // field dependency logic
    if (!parentSelectedOptions.includes(selectedOption!.value)) {
      parentSelectedOptions.push(selectedOption!.value);
    }
  }

  // field dependency logic
  const updatedAttributes =
    parentMap.get(parent)?.child.map((child) => {
      if (child.attributeCode === value.attributeCode) {
        attributeOptionToUpdate.labelOptions.options =
          attributeOptionToUpdate.labelOptions.options.map((option) => {
            option.isDisabled = child.isProduct
              ? !isOptionEnable(
                  parentSelectedOptions,
                  option.enabledWithOptionIds
                )
              : false;
            return option;
          });
        return attributeOptionToUpdate;
      }
      child.labelOptions.options = child.labelOptions.options.map((option) => {
        option.isDisabled = child.isProduct
          ? !isOptionEnable(parentSelectedOptions, option.enabledWithOptionIds)
          : false;
        return option;
      });
      return child;
    }) || [];

  groupParentAttributeOptionSet.get(groupKey)!.parents.get(parent)!.child =
    updatedAttributes;
  groupParentAttributeOptionSet
    .get(groupKey)!
    .parents.get(parent)!.parentSelectedOptions = parentSelectedOptions;

  return groupParentAttributeOptionSet;
}

// field dependency logic
export function isOptionEnable(
  selectedOptions: string[],
  OptionsAvailable: any
) {
  if (OptionsAvailable.length === 0) return false;
  // let bool = selectedOptions.every(option => OptionsAvailable.includes(option))
  return selectedOptions.every((option) => OptionsAvailable.includes(option));
}

// DeepClone function for formData
export function formDataDeepClone(
  obj: GroupParentAttributeOptionSet
): GroupParentAttributeOptionSet {
  return Deserialize.groupParentAttributeOptionSet(
    Serialize.groupParentAttributeOptionSet(obj)
  )!;
}
type Item = {
  id: string;
  name: string;
  [key: string]: any; // Allow other dynamic properties
};

export const buildObjectFromArray = (items: Item[]): Record<string, any> => {
  const result: Record<string, any> = {};

  items.forEach((item) => {
    const key = item.name;

    // Find the property that ends with 'Value'
    const valueKey = Object.keys(item).find((k) => k.endsWith("Value"));

    if (key && valueKey) {
      result[key] = item[valueKey];
    }
  });

  return result;
};

export function resetGroupParentAttributeOptionSet(
  original: GroupParentAttributeOptionSet
): GroupParentAttributeOptionSet {
  const updated = new Map<string, GroupParentAttributeOptionSetValue>();

  original.forEach((groupValue, groupKey) => {
    const updatedParents = new Map<string, ParentAttributeOptionSet>();

    groupValue.parents.forEach((parentValue, parentKey) => {
      const updatedChildren = parentValue.child.map((childAttr) => ({
        ...childAttr,
        selectedOption: {
          label: "",
          value: "",
          isDisabled: true,
        },
      }));

      updatedParents.set(parentKey, {
        ...parentValue,
        parentSelectedOptions: [],
        child: updatedChildren,
      });
    });

    updated.set(groupKey, {
      ...groupValue,
      parents: updatedParents,
    });
  });

  return updated;
}

// Create or Get Global Option Resource
export const getGroupAttributeCodeSetSourceData =
  async (globalPickFormData:any): Promise<GroupAttributeCodeSetSource> => {
    try {
      const existingGlobalResourceData =
        globalOptionResources.getGroupAttributeCodeSetSource();
      if (existingGlobalResourceData && existingGlobalResourceData.size > 0) {
        return existingGlobalResourceData;
      }

      const [fetchedFormFieldsData] = await Promise.all([
        getFormFields("Power Picks", "1"),
      ]);

      const formFieldsData = fetchedFormFieldsData?.data?.GetFormFields;
      if (!formFieldsData) {
        throw new Error("Failed to fetch form fields data for Power Picks");
      }

      const attributeSet = formFieldsData?.attributeSet;
      const attributeGroup = formFieldsData?.attributeSetGroup;
      const groupAttributesCodesSet = formFieldsData.bodyAttributes;

      const formFields = createGroupByAll(attributeSet, attributeGroup);
      const groupAttributeCodeSetSource = getGroupAttributeCodeSetSource(
        groupAttributesCodesSet,
        formFields
      );

      const globalDependentAttributeSets: string[] = [];
      globalPickFormData.forEach((group: any) => {
        group.parent.forEach((parent: any) => {
          if (parent.is_global_to_global_dependent) {
            globalDependentAttributeSets.push(parent.group_parent_label.replace('Default', '').trim());
          }

          if (parent.filter_by_group?.length) {
            let dependentOnName: any = [];
            parent.filter_by_group.forEach((groupkey: any) => {
              groupAttributeCodeSetSource.forEach((value: any, key: any) => {
                if (key === groupkey) {
                  dependentOnName.push(value.groupName);
                }
              });
            });
            groupAttributeCodeSetSource.forEach((value: any) => {
              if (value.groupName === parent.group_parent_label.replace('Default', '').trim()) {
                value.dependentOn = dependentOnName;
              }
            });
          }

          groupAttributeCodeSetSource.forEach((value: any) => {
            if (value.groupName === parent.group_parent_label.replace('Default', '').trim()) {
              value.attributeSetId = parent.attribute_set
            }
          })

        });
      });
      
      globalDependentAttributeSets.forEach((groupName: string) => {
        groupAttributeCodeSetSource.forEach((value: any) => {
          if (value.groupName === groupName) {
            value.attributeCodeSet.forEach((attributeCodeSet: any) => {
              attributeCodeSet.source = "global";
            });
          }
        });
      });

      globalOptionResources.setGroupAttributeCodeSetSource(
        groupAttributeCodeSetSource
      );

      return groupAttributeCodeSetSource;
    } catch (error) {
      console.error("Error fetching groupAttributeCodeSetSource data:", error);
      throw new Error("Failed to retrieve groupAttributeCodeSetSource data");
    }
  };

export const areGlobalSelectionEqual = (arr1: any, arr2: any)=> {
  if (arr1.length !== arr2.length) return false;

  const sortFn = (a: any, b: any) => a.key.localeCompare(b.key);

  const sorted1 = [...arr1].sort(sortFn);
  const sorted2 = [...arr2].sort(sortFn);

  return sorted1.every((obj1, index) => {
    const obj2 = sorted2[index];
    return Object.keys(obj1).every(key => obj1[key] === obj2[key]);
  });
};

export const mapDukeActiveStructure = (
  groupParentAttributeOptionSet: GroupParentAttributeOptionSet,
  initializeEmpty: boolean = false
): GlobalOptions[] => {
  const globalOptionsArray: GlobalOptions[] = [];
  for (const [groupKey, groupData] of groupParentAttributeOptionSet.entries()) {
    for (const [parentKey, parentData] of groupData.parents.entries()) {
      for (const attribute of parentData.child) {
        globalOptionsArray.push({
          group_name: groupData.groupName,
          group_key: groupKey,
          parent_name: parentKey === "default" ? "" : parentKey,
          key: attribute.attributeCode,
          value: initializeEmpty
            ? ""
            : (attribute.selectedOption?.value ?? null),
          label: initializeEmpty ? "" : (attribute.selectedOption?.label ?? ""),
          isMultiselect: attribute.isMultiselect,
        });
      }
    }
  }

  return globalOptionsArray;
};